module.exports = __webpack_public_path__ + "img/k3p_tip_ico.39122dac.png";